<template>
    <div class="page-loading text-xs-center">
        <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
        <div >Загрузка...</div>
    </div>
</template>

<script>
    export default {
        components: {},
        data () {
            return {}
        },
        props: {},
        computed: {},
        methods: {}
    }
</script>

<style lang="stylus" scoped>
    .page-loading {
        padding 50px 0
    }
</style>
